import React, {Component} from 'react';
import LogowanieService from "../../logowanie/LogowanieService";
import HomeService from "../HomeService";
import {TopAlertInformacja, TopAlertOstrzezenie, TopAlertUwaga} from "../../../componentsTopsa/alerty/TopAlerts";
import {TopButtonAction} from "../../../componentsTopsa/buttons/TopButtons";
import {QRCode} from "react-qr-svg";
import ReactNotify from 'react-notify';


export default class KluczMobilnyTabContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            czyIstniejeKluczMobilny: false,
            setLoader: false,
            czyError: false,

        };

    }

    componentDidMount() {
        this.setState({czyIstniejeKluczMobilny: Boolean(LogowanieService.pobierzZalogowanego().mobileKey)})
    }

    generujWartoscDoKlucza() {
        return LogowanieService.pobierzLoginZalogowanego().substr(0, 2) + '_' + new Date().getTime()
    }

    wyslijIwygenerujKluczMobilny() {
        this.setState({setLoader: true, czyError: false})
        let klucz = this.generujWartoscDoKlucza()

        HomeService.wyslijInformacjeOKluczuMobilnym(klucz).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie wygenerowano klucz mobilny', "", 3000)

                let localobject = LogowanieService.pobierzZalogowanego()
                LogowanieService.wyloguj()
                localobject['mobileKey'] = klucz
                LogowanieService.zalogujUzytkownika(localobject, localobject.token)

                this.setState({setLoader: false, czyError: false, czyIstniejeKluczMobilny: true})
            } else {
                this.setState({setLoader: false, czyError: true, czyIstniejeKluczMobilny: false})
                this.refs.notificator.error('Wystąpił błąd podczas próby wygenerowania klucza mobilnego', "", 3000)

            }
        }.bind(this)).catch(function (err) {
            this.setState({setLoader: false, czyError: true, czyIstniejeKluczMobilny: false})
            this.refs.notificator.error('Wystąpił błąd podczas próby wygenerowania klucza mobilnego', "", 3000)

        }.bind(this))
    }

    usunKluczMobilny() {

        this.setState({setLoader: true, czyError: false})


        HomeService.wyczyscKluczMobilny().then(function (response) {
            if (response.status < 300) {
                this.setState({setLoader: false, czyError: false, czyIstniejeKluczMobilny: false})
                this.refs.notificator.success('Pomyślnie dezaktywowano klucz mobilny', "", 3000)

                let localobject = LogowanieService.pobierzZalogowanego()
                LogowanieService.wyloguj()
                localobject['mobileKey'] = null
                LogowanieService.zalogujUzytkownika(localobject, localobject.token)

            } else {
                this.setState({setLoader: false, czyError: true, czyIstniejeKluczMobilny: true})
                this.refs.notificator.error('Wystąpił błąd podczas próby dezaktywowania klucza mobilnego', "", 3000)

            }
        }.bind(this)).catch(function (err) {
            this.setState({setLoader: false, czyError: true, czyIstniejeKluczMobilny: true})
            this.refs.notificator.error('Wystąpił błąd podczas próby dezaktywowania klucza mobilnego', "", 3000)
        }.bind(this))

    }

    render() {

        return (
            <div>
                <ReactNotify ref='notificator'/>

                {this.state.setLoader ?
                    <div style={{width: '400px'}}>
                        <div id={'smallLoader'}>
                            <i className={'fa fa-circle-o-notch fa-spin'}></i>
                            <div>Trwa oczekiwanie na odpowiedź...</div>
                        </div>
                    </div>
                    :
                    this.state.czyError ?
                        <div>
                            <TopAlertUwaga text={'Wystąpił błąd'}/>
                            <TopButtonAction text={'Spróbuj ponownie'} iconType={'fa fa-refresh'} onClick={() => this.setState({
                                czyIstniejeKluczMobilny: false,
                                setLoader: false,
                                czyError: false,
                            })}/>
                        </div>
                        :
                        this.state.czyIstniejeKluczMobilny ?
                            <div>
                                <TopAlertInformacja text={'Wygenerowany klucz mobilny - zeskanuj poniższy kod QR'}/>
                                <div>

                                    {
                                        Boolean(LogowanieService.pobierzZalogowanego().mobileKey) ?
                                            <div>
                                            <div className={'thumbnail'} style={{width: '350px', padding: '30px'}}>
                                                <QRCode
                                                    bgColor="#FFFFFF"
                                                    fgColor="#000000"
                                                    level="M"
                                                    style={{width: '100%'}}
                                                    value={this.props.QR_URL+';'+LogowanieService.pobierzZalogowanego().mobileKey+';'+LogowanieService.pobierzLoginZalogowanego()}
                                                />
                                            </div>
                                                <div style={{color:'grey', fontSize:'12px', margin:'0 0 25px 0'}}>
                                                    <span>{this.props.QR_URL+';'+LogowanieService.pobierzZalogowanego().mobileKey+';'+LogowanieService.pobierzLoginZalogowanego()}</span>
                                                </div>
                                            </div>
                                            :
                                            <TopAlertUwaga text={'Nie można wczytać kodu'}/>
                                    }
                                </div>
                                <TopButtonAction text={'Dezaktywuj klucz dostępu'} iconType={'fa fa-ban'} onClick={() => this.usunKluczMobilny()}
                                                 btnColor={'danger'}/>
                            </div>
                            :
                            <div>
                                <TopAlertOstrzezenie text={'Brak aktywnego klucza mobilnego'}/>
                                <TopButtonAction text={'Wygeneruj klucz dostępu'} iconType={'fa fa-qrcode'}
                                                 onClick={() => this.wyslijIwygenerujKluczMobilny()}/>
                            </div>
                }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/home/kluczmobilny/KluczMobilnyTabContainer.js